import {delay} from 'redux-saga';
import {put, fork, cancel, call, take, select, race} from 'redux-saga/effects';
import ApiActions from 'go/actions/api';
import Cookies from 'universal-cookie';
import {isTokenNewer} from '../../common/utils';
import _ from 'lodash';
import {
  API_AUTH_LOGIN_SUCCESS,
  LOGOUT,
  API_AUTH_REFRESH_SUCCESS,
  COOKIE_POLL_INTERVAL,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
  API_PROFILE_GET_SUCCESS,
} from 'common/types';
import goStore from 'go/store';

const cookies = new Cookies(null, {path: '/'});

export default function* loginSaga() {
  yield call(waitForLogin);
}

export function* waitForLogin() {
  yield take(API_AUTH_LOGIN_SUCCESS);
  yield call(setUpUserAfterLogin);
  const task = yield fork(loginFlow);
  yield take(LOGOUT);
  yield cancel(task);
  yield call(waitForLogin);
}

export function* setUpUserAfterLogin() {
  const state = yield select();
  const token = getTokenFromState(state);
  const userId = token.userId;
  const jwt = state && state.auth ? state.auth.token : '';
  yield put(ApiActions.profile.getUser(userId, jwt));
  yield take(API_PROFILE_GET_SUCCESS);
  const freshProfile = yield select((state) => state.profile);
  yield put({
    type: [DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS],
    meta: {objectType: 'profile', optional: true},
    payload: freshProfile,
  });

  yield put(ApiActions.userEntities.getUserEntities(jwt));
}

export function* loginFlow() {
  let logoutTask;
  const state = yield select();
  const toggles = state?.toggles?.toggles;
  const token = getTokenFromState(state);
  let time = calculateTimeToDelay(token);
  if ((_.includes(toggles), 'createFoV2')) {
    logoutTask = yield fork(forceLogoutRefactored, time);
  } else {
    logoutTask = yield fork(forceLogout, time);
  }
  yield take(API_AUTH_REFRESH_SUCCESS);
  yield cancel(logoutTask);
  yield call(loginFlow);
}

export function getTokenFromState(state) {
  let token = '';
  if (state !== undefined && state.auth !== undefined && state.auth.token !== undefined) {
    token = state.auth.token;
  }
  return token;
}

export function calculateTimeToDelay(token) {
  let iat = createDateFromSeconds(token.iat);
  let exp = createDateFromSeconds(token.exp);
  return exp - iat;
}

export function createDateFromSeconds(value) {
  return new Date(value * 1000);
}

export function* forceLogout(time) {
  yield delay(time);
  yield put(ApiActions.auth.logout());
}

export function* forceLogoutRefactored(time) {
  const {timedOut} = yield race({
    timedOut: delay(time),
    refreshed: call(pollForCookieRefresh),
  });

  if (timedOut) {
    // cookie never got refreshed from either app
    yield put(ApiActions.auth.logout());
  }
}

export function* pollForCookieRefresh() {
  while (true) {
    yield delay(COOKIE_POLL_INTERVAL);
    const cookieToken = cookies.get('token');
    if (!cookieToken) continue;
    const state = yield select();
    const stateToken = state?.auth?.token;
    if (!stateToken || isTokenNewer(cookieToken, stateToken)) {
      yield put(ApiActions.auth.refresh());
      return; // exits pollForCookieRefresh, losing the race to "refreshed"
    }
  }
}
